<template>
    <div>
        <v-expansion-panels elevation="0">
            <v-expansion-panel elevation="0">
                <v-expansion-panel-header style="padding: 35px">
                    <h3 style="color: #42352e">Búsqueda por fechas de cancelación</h3>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                        <v-row>
                            <v-col v-for="item in fechasCancelaciones" :key="item.fechaCancelacion" cols="12" md="4">
                                <v-card class="pa-3" outlined style="cursor:pointer" :disabled="(form.fecha === item.fechaCancelacion)"
                                    :class="{ 'selected-card': form.fecha === item.fechaCancelacion }"
                                    @click="selectFecha(item.fechaCancelacion)">
                                    <div class="d-flex justify-space-between align-center">
                                        <div>
                                            <v-icon>mdi-calendar</v-icon>
                                            <strong> {{ item.fechaCancelacion }}</strong>
                                        </div>
                                        <v-chip small color="primary" text-color="white">
                                            {{ item.total }}
                                        </v-chip>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { obtenerFechasCancelaciones } from "@/services/cancelacionService";

export default {
    data() {
        return {
            form: {
                fecha: null,
            },
            fechasCancelaciones: [],
        };
    },
    methods: {
        async getFechasCancelaciones() {
            const response = await obtenerFechasCancelaciones();
            const fechaLimite = new Date('2026-01-01');
            this.fechasCancelaciones = (response.data.values || [])
                .filter(item =>
                    item?.fechaCancelacion &&
                    new Date(item.fechaCancelacion) >= fechaLimite
                );
        },
        selectFecha(fecha) {
            this.form.fecha = fecha;
            this.$emit("searchUpdated", this.form);
        }
    },
    mounted() {
        this.getFechasCancelaciones();
    },
};
</script>

<style scoped>
.v-expansion-panel {
    border-radius: 20px;
}

.v-expansion-panels {
    z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)>.v-expansion-panel--active {
    border-radius: 20px !important;
    background-color: #fcf2f2;
}

.v-expansion-panel-header {
    background-color: #fcf2f2;
    border-radius: 20px !important;
}

</style>
